import { Component, OnInit, Input } from '@angular/core';
import {
  Process,
  ProcessReportSetting,
} from '../../../../models/process-models';
import { ProcessService } from '../../../../services/process.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SaveFormService } from '../../../../services/save-form.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-process-report-settings',
  templateUrl: './process-report-settings.component.html',
  styleUrls: ['./process-report-settings.component.scss'],
})
export class ProcessReportSettingsComponent implements OnInit {
  @Input() process: Process;
  subscription: Subscription;
  reportSetting = ProcessReportSetting;
  formGroup: FormGroup;
  isToggle = true;
  descriptionControlPrefix = 'scaleDescription_';
  descriptions: Array<string> = [];
  descriptionPlaceholders: Array<string> = [];

  constructor(
    private processService: ProcessService,
    private formService: SaveFormService,
    private formBuilder: FormBuilder
  ) {
    this.subscribeOnSave();
  }

  ngOnInit() {
    if (!this.process.reportSettings) {
      this.process.reportSettings = [];
    }
    this.formGroup = this.formBuilder.group({});
    this.formService.addAllLocalizedNameToFormGroup(
      this.formGroup,
      this.descriptionControlPrefix,
      this.process.scaleDescription
    );
    this.descriptions = this.formService.mapFormGroupControlToPropArray(
      this.formGroup,
      this.descriptionControlPrefix
    );

    this.setPlaceholders();
  }

  toggleSetting(settingItem: number) {
    this.processService.toggleEnumSetting(
      this.process.reportSettings,
      settingItem
    );
  }

  getIsCategoryChartDisabled() {
    return !this.processService.getIs360SetOnly(this.process);
  }

  getIsSet(settingItem: number) {
    return this.process.reportSettings.indexOf(settingItem) !== -1;
  }

  private setPlaceholders() {
    const allControls = this.formService.getAllFormControlsFields(
      this.formGroup.controls
    );
    const descriptionControls = this.formService.getControlsByControlName(
      this.descriptionControlPrefix,
      allControls
    );
    this.descriptionPlaceholders = this.formService.setPlaceholderArrayByPropName(
      descriptionControls,
      'Enter the scale description in'
    );
  }

  private saveReportSettings() {
    this.process.scaleDescription = this.formService.mapFormvalueToQuestion(
      this.formGroup.value,
      this.descriptionControlPrefix
    );
  }

  private subscribeOnSave() {
    if (this.subscription) {
      return;
    }
    this.subscription = this.processService.saveProcessClicked$.subscribe(() =>
      this.saveReportSettings()
    );
  }
}
